import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getClassificationColor, formatPrice } from '../../utils/wineHelpers';

const WineCard = ({ wine }) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  return (
    <div
      onClick={() => navigate(`/wine/${wine.slug}`)}
      className="cursor-pointer group"
    >
      <div className="bg-gradient-to-br from-[#2a2535] to-[#1a1625] rounded-2xl p-4 md:p-5 tablet-landscape:p-3 hover:scale-105 transition-transform duration-300">
        <div className="h-36 sm:h-40 md:h-44 tablet-landscape:h-32 bg-gradient-to-br from-[#3a3545] to-[#2a2535] rounded-xl mb-3 flex items-center justify-center overflow-hidden">
          {imageError ? (
            <div className="w-20 h-48 bg-gradient-to-b from-[#4a2525] via-[#2a1515] to-[#1a0a0a] rounded-full" />
          ) : (
            <img
              src={wine.image}
              alt={wine.name}
              className="max-h-full max-w-full object-contain"
              onError={() => setImageError(true)}
            />
          )}
        </div>

        <h3 className="text-white text-base md:text-lg tablet-landscape:text-sm font-serif text-center mb-2 line-clamp-2">
          {wine.name}
        </h3>
        <div className="flex items-center justify-center gap-2 mb-3">
          <span className={`px-2 py-1 rounded-full text-xs font-semibold uppercase ${getClassificationColor(wine.classification)}`}>
            {wine.classification}
          </span>
          <p className="text-gray-400">{wine.grape}</p>
        </div>
        <p className="text-wine-gold text-lg md:text-xl tablet-landscape:text-base text-center font-medium">
          {formatPrice(wine.price)}
        </p>
      </div>
    </div>
  );
};

export default WineCard;
